<template>
  <div class="body_container">
    <Contact></Contact>
    <div class="width_margin">
      <div class="container_content_list_title">조직 진단</div>
    </div>

    <div class="width_margin">
      <div class="container_content_list">
        <div class="container_content_list_img">
          <img src="@/assets/img/global/sub_page_communication38.png" />
          <div class="container_content_list_box">
            <div class="container_content_list_img_text">
              <div class="container_content_list_left_icon"></div>
              <div class="container_content_list_right_text">
                #임직원 마음건강
              </div>
            </div>
          </div>
        </div>
        <div class="container_content_text_list">
          <div class="container_content_text_title_down_container">
            <div class="container_content_text_title1">
              조직 마음 건강 진단 : MSS
            </div>
            <!-- <div class="container_content_download"><img class="container_right_download_img" src="@/assets/img/global/sub_page_down_img.png" />Download</div> -->
          </div>
          <div class="container_content_text_title">
            조직 구성원들의 5대 마음건강 영역을 진단하여 조직과 개인에 과학적
            맞춤 솔루션을 제공합니다.
          </div>
          <div class="container_content_text_content">
            스트레스가 많은 직군 혹은 불확실성이 큰 직군 직원들의 정신건강 상태
            파악하고 조직의 성장 도모하기 위한 개입 방안 모색 가능<br />
            5가지 정신건강 요인 (회복탄력성, 탈진, 분노관리, 직무만족도, 삶의
            만족도) 측정<br />
            총 95개 문항을 30분 내 온라인으로 응시 완료 가능하며 체계적인 개인별
            보고서 제공
          </div>
        </div>
      </div>

      <div class="container_content_list">
        <div class="container_content_list_img">
          <img src="@/assets/img/global/sub_page_communication39.png" />
          <div class="container_content_list_box">
            <div class="container_content_list_img_text">
              <div class="container_content_list_left_icon"></div>
              <div class="container_content_list_right_text">#에니어그램</div>
            </div>
          </div>
        </div>

        <div class="container_content_text_list">
          <div class="container_content_text_title_down_container">
            <div class="container_content_text_title1">
              성격유형 검사 : 에니어그램
            </div>
            <!-- <div class="container_content_download"><img class="container_right_download_img" src="@/assets/img/global/sub_page_down_img.png" />Download</div> -->
          </div>
          <div class="container_content_text_title">
            에니어그램 검사는 사람을 9가지 성격으로 분류하는 성격 유형 지표이자
            인간을 이해하는 유용한 검사로, 임직원의 기본 성향과 기질에 따른 업무
            스타일, 적합한 직무배치, 갈등 등을 이해하는데 도움이 되는
            검사입니다.
          </div>
          <div class="container_content_text_content">
            자신의 성격을 이해하고 변화를 추구, 타인의 성격 유형을 이해함으로써
            인간관계의 갈등을 해소하여 리더십 과정이나 팀빌딩 향상 과정에
            적합<br />
            내 유형 특성 키워드, 심리적 배경, 내 유형의 삶의 방식 이해 및 가장
            성숙한 상태의 나, 변화와 성장을 위한 조언 포함<br />
            30분간 온라인 검사 가능, 총 144개 문항을 바탕으로 유형별 역량과
            가치를 이해하는 진단과 이를 바탕으로 한 사후 워크숍 과정으로 구성
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Contact from "@/components/Global/ContactUs.vue";
export default {
  components: {Contact},
  name: "Organizationalcompetency",
};
</script>

<style></style>
